<template>
  <div class="page">
    <Header title="博世学堂" :show-back="true"  />

    <van-cell-group>
      <van-cell v-for="category in categoryList" :key="category.categoryId" :title="category.categoryName" is-link @click="viewCategory(category)" />
      <van-cell title="博世企业培训平台" is-link @click="goToELearning()" />
    </van-cell-group>
  </div>
</template>

<script>
import Header from '@/components/header'
import courseApi from '@/api/course'
// import { commonUtils } from '@/utils/common'
export default {
  name: 'CourseCategoryList',
  components: {
    Header
  },
  data () {
    return {
      categoryList: []
    }
  },
  created () {
    this.queryCategoryList()
  },
  methods: {
    // backToMainSite () {
    //   window.location.replace(commonUtils.getExtraSite())
    // },
    queryCategoryList () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '读取数据'
      })
      courseApi.queryCourseCategoryList().then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          this.categoryList = response.data.resultData.courseCategoryList
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },

    viewCategory (category) {
      this.$router.push({ name: 'course-list', params: { categoryId: category.categoryId } })
    },
    goToELearning () {
      window.open('http://elearning.boschcarservice.com.cn/wx/checkLogin.do?functionName=wxElnIndex&corpCode=lbox&wxType=SUBSCRIBE')
    }
  }
}
</script>

<style>

</style>
